<template>
  <v-app class="houseScroll">

    <div class="textcontent">
      <!--<button class="closebutton" onclick="location.href = './index.html'">x</button>-->
      <img class="closebutton" onclick="location.href = './resist.html'" src="./x.png" type="button">

      <h1 class="spaceout">References</h1>
      <p class="spaceout">
        These news articles are all referenced in the game.
      </p>
      <div v-for="item in blurbArray" :key="item.img" class="referenceItem" @click="openExternalLink(item.link)">
        <img class="referenceImg" :src="require('./assets/' + item.img)"><div><p class="referenceTitle">{{ item.title }}(<i>{{ item.source }}</i>)</p> <p class="referenceBlurb">{{ item.blurb }}</p></div>
      </div>



      <div class="endDiv middle">
        <button class="buttonclass stuffOnTopIndex" onclick="location.href='./resist.html'" type="button">
          Go back</button>
      </div>
    </div>

  </v-app>
</template>

<script>
import vuetify from './plugins/vuetify'
import './assets/style.css';
import story from './story.json';

let slides = story.chapters[0].slides
let kopArray = []
let blurbArray = []
slides.forEach(appendLinks)

function appendLinks(item) {
  if (item.truthCheck) {
    item.truth.choices.forEach(appendLinksTruth)
  }
}

function appendLinksTruth(item) {
  if (!kopArray.includes(item.img)) {
    kopArray.push(item.img)
    blurbArray.push(item)
  }
}


export default {
  name: 'AppRefs',
  components: {
  },
  data() {
    return {
      dialog: false,
      inMiddleOfGame: false,
      hasPlayedOnce: false,
      blurbArray: blurbArray,
      kopArray: kopArray
    }
  },
  methods: {
        openExternalLink(link) {
            window.open(link, '_blank')
        }
  },
  mounted() {
    if (localStorage.getItem("slide") === null) {
      this.inMiddleOfGame = false
    }
    else {
      this.inMiddleOfGame = true
    }
    if (localStorage.getItem("playedOnce") === null) {
      this.hasPlayedOnce = false
    }
    else {
      this.hasPlayedOnce = true
    }
  }

}

</script>
